import { FC } from 'react';

import { WorkflowStepFormFieldSelect } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const SelectFieldToBlock: FieldToBlock<
  'select',
  WorkflowStepFormFieldSelect
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'select',
  componentProps: {
    options: field.options,
    size: 'sm',
    hidePlaceholder: field.required,
  },
});

type SelectFieldValueProps = FieldValueProps<'select'>;

export const SelectFieldValue: FC<SelectFieldValueProps> = ({ field }) => {
  // TODO: this does not currently support "groups"
  const option = field.options.find((o) => o.value === field.value);

  return <>{((option && option.label) || field.value) ?? '–'}</>;
};
